import {IonIcon, IonItem, IonLabel, IonMenuToggle} from '@ionic/react';
import {volumeHighOutline} from 'ionicons/icons';
import React from 'react';

interface AsteriskMessagesMenuItemProps {
    isActive: boolean;
    onNavigate: () => void;
}

const AsteriskMessagesMenuItem: React.FC<AsteriskMessagesMenuItemProps> = ({isActive, onNavigate}) => {
    return (
        <IonMenuToggle auto-hide="false">
            <IonItem button onClick={onNavigate} className={isActive ? 'selected' : 'not-selected'}>
                <IonIcon slot="start" icon={volumeHighOutline}/>
                <IonLabel>Telefoonberichten</IonLabel>
            </IonItem>
        </IonMenuToggle>
    );
};

export default AsteriskMessagesMenuItem;
